import { render } from "./_index.vue?vue&type=template&id=58917d06&scoped=true&lang=pug"
import script from "./_index.vue?vue&type=script&lang=js"
export * from "./_index.vue?vue&type=script&lang=js"

import "./_index.vue?vue&type=style&index=0&id=58917d06&scoped=true&lang=css"

import exportComponent from "/Users/trevorseo/work/chekt-app-rook/web/rook/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58917d06"]])

export default __exports__
import QMarkupTable from 'quasar/src/components/markup-table/QMarkupTable.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMarkupTable,QAvatar,QSeparator});
